import { render, staticRenderFns } from "./SidebarStyle2.vue?vue&type=template&id=c8a4a7c8"
import script from "./SidebarStyle2.vue?vue&type=script&lang=js"
export * from "./SidebarStyle2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports